import { render, staticRenderFns } from "./newsAndInformation.vue?vue&type=template&id=17ebf7ed&scoped=true"
import script from "./newsAndInformation.vue?vue&type=script&lang=js"
export * from "./newsAndInformation.vue?vue&type=script&lang=js"
import style0 from "./newsAndInformation.vue?vue&type=style&index=0&id=17ebf7ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ebf7ed",
  null
  
)

export default component.exports